/** @jsx jsx */
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { AppState } from './redux-modules/root';
import AppShell from './AppShell';
import { jsx } from '@emotion/core';
import { domainPath } from './App';
export interface PrivateRouteProps extends RouteProps {
    appState: AppState;
    user: any;
    roles: any;
    tab: string;
}

const PRoute: React.FC<PrivateRouteProps> = (props) => {
    const { user, roles, tab, ...routeProps } = props;
    //const { user } = appState;
    //const accessToken = store.getState().user.user.accessToken;
    let role = sessionStorage.user_role
        ? sessionStorage.user_role === undefined
            ? ''
            : sessionStorage.user_role === 'undefined'
            ? ''
            : sessionStorage.user_role
        : '';
        let menu_list = user && user.user && user.user.tab_menu_list ? user.user.tab_menu_list : []
        
    if (sessionStorage.refreshToken === undefined) {
        return (
            <React.Fragment>
                <Redirect
                    to={{
                        pathname: `/${domainPath}/login`,
                        state: { from: routeProps.location }
                    }}
                />
            </React.Fragment>
        );
    } else if (menu_list.includes(tab)) {
        return (
            <React.Fragment>
                <AppShell>
                    {' '}
                    <Route {...routeProps} />
                </AppShell>
            </React.Fragment>
        );
    } else if (roles.includes(role)) {
        return (
            <React.Fragment>
                <AppShell>
                    {' '}
                    <Route {...routeProps} />
                </AppShell>
            </React.Fragment>
        );
    } else {
        return (
            <React.Fragment>
                <Redirect
                    to={{
                        pathname: `/${domainPath}/access_denied`,
                        state: { from: routeProps.location }
                    }}
                />
            </React.Fragment>
        );
    }
};

const mapStateToProps = (state: AppState) => {
    return {
        user: state.user,
        appState: state
    };
};

export default connect(mapStateToProps)(PRoute);
